import { createAction, props } from "@ngrx/store";
import { PaginationRequest } from "src/app/models/common/paginationRequest";

export const resetProductsState = createAction(
  "[Products] Reset Products State Action"
);
export const resetCreation = createAction("[Products] Reset Creation Action");
export const getProductsList = createAction(
  "[Products] Get All Products List Action",
  props<{ options: any }>()
);
export const loadProductsList = createAction(
  "[Products] Load All Products List Action",
  props<{ response: any[] }>()
);
export const getProductsExcelList = createAction(
  "[Products] Get All Products Excel List Action",
  props<{ options: any }>()
);
export const loadProductsExcelList = createAction(
  "[Products] Load All Products Excel List Action",
  props<{ response: any[] }>()
);
// Table Configuration Settings
export const getProductsTableConfig = createAction(
  "[Products] Get Products Table Configuration Action",
  props<{ options: any }>()
);
export const loadProductsTableConfig = createAction(
  "[Products] Load Products Table Configuration Action",
  props<{ response: any[] }>()
);
export const saveProductsTableConfig = createAction(
  "[Products] Save Products Table Configuration Action",
  props<{ config: any }>()
);
export const createProduct = createAction(
  "[Products] Create Product Action",
  props<{ product: any }>()
);
export const updateProduct = createAction(
  "[Products] Update Product Action",
  props<{ product: any }>()
);
export const getProduct = createAction(
  "[Products] Get Product Action",
  props<{ code: string }>()
);
export const loadProduct = createAction(
  "[Products] Load Product Action",
  props<{ response: any }>()
);
export const getGroupProductsList = createAction(
  "[Products] Get All Group Products List Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadGroupProductsList = createAction(
  "[Products] Load All Group Products List Action",
  props<{ response: any[] }>()
);
export const getFamilyProductsList = createAction(
  "[Products] Get All Family Products List Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadFamilyProductsList = createAction(
  "[Products] Load All Family Products List Action",
  props<{ response: any[] }>()
);
export const getUnitProductsList = createAction(
  "[Products] Get All Unit Products List Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadUnitProductsList = createAction(
  "[Products] Load All Unit Products List Action",
  props<{ response: any[] }>()
);
export const getProductTypesList = createAction(
  "[Products] Get All Product Types List Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadProductTypesList = createAction(
  "[Products] Load All Product Types List Action",
  props<{ response: any[] }>()
);
export const getBarcodeTypes = createAction(
  "[Products] Get All Barcode Types List Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadBarcodeTypes = createAction(
  "[Products] Load All Barcode Types List Action",
  props<{ response: any[] }>()
);

export const getWarehouseProductsList = createAction(
  "[Products] Get All Warehouse Products List Action",
  props<{ options: any }>()
);
export const loadWarehouseProductsList = createAction(
  "[Products] Load All Warehouse Products List Action",
  props<{ response: any[] }>()
);
export const getCategoriesByUsage = createAction(
  "[Products] Get All Categories by Usage Action",
  props<{ pageReq: PaginationRequest; usageCode: string }>()
);
export const loadCategoriesByUsage = createAction(
  "[Products] Load All Categories by Usage Action",
  props<{ response: any[] }>()
);
export const getPropertiesByUsage = createAction(
  "[Products] Get All Properties by Usage Action",
  props<{ pageReq: PaginationRequest; usageCode: string }>()
);
export const loadPropertiesByUsage = createAction(
  "[Products] Load All Properties by Usage Action",
  props<{ response: any[] }>()
);

export const createSiteList = createAction(
  "[Products] Create Product Site List Action",
  props<{ productCode: string, productList: any[] }>()
);
export const getProductSiteList = createAction(
  "[Products] Get Product Site List Action",
  props<{ code: string }>()
  );
export const loadProductSiteList = createAction(
  "[Products] Load Product Site List Action",
  props<{ response: any[] }>()
);

export const setLoadingStartState = createAction(
  "[Products] Set Product Loading Start State Action"
);
export const setLoadingEndState = createAction(
  "[Products] Set Product Loading End State Action"
);

export const resetProduct = createAction("[Products] Reset Product Action");
